import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.HierarchyNavigationBarsChartView extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/monitoring/charts/generic_chart']
  template_path: JST['backbone/templates/monitoring/charts/tree_path']
  hierarchySelectingTemplate: JST["backbone/templates/monitoring/hierarchy_select"]
  className: 'processing item w2 bars-chart'

  events:
    'click .subpath': 'onSubpath'
    'mouseover .subpath': 'onMouseOver'
    'mouseout .subpath': 'onMouseOut'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'
    'click .taxonomyChoise': 'changeTaxonomy',
    'click #change_hierarchy': 'onClickChangeHierarchy'

  initialize: (@options = {}) =>
    @title = I18n.t('monitoring.dashboard.charts.h_navigation_bars')
    @title_en = I18n.t('monitoring.dashboard.charts.h_navigation_bars', {'locale': 'en'})
    @path = @options.settings.path || []
    @inClickWindowTime = false
    @searchQuery = @options.searchQuery
    @_settings = @options.settings
    @_settings.maximized = !!@_settings.maximized
    @_settings.currentTaxonomyCode = @_settings.currentTaxonomyCode || 'Default'
    @container = @options.container
    @tags_limit = 10
    @_settings['reduced_tree'] = true
    @taxonomiesRepository = new Monitoring.Models.TaxonomiesRepository
    
  render: ->
    @$el.html(@template({
      title: @title
    }))
    if @_settings.maximized then @$el.toggleClass('h2')
    return this

  afterAppend: ->
    if @hierarchyNavigator
      @data = @hierarchyNavigator.extractData()
      @_settings.path = @path
      @trigger('chartsChange')
      @afterAppendHTML()
    else
      @taxonomiesRepository.loadAlternativeTaxonomies(() =>
        @$el.find('#close_chart').before(@hierarchySelectingTemplate(
          includeAlternativeTaxonomies: Keepcon.currentAccount.includeAlternativeTaxonomies,
          taxonomiesRepository: @taxonomiesRepository
        ))
        query = @searchQuery.toJSON()
        query.taxonomy_code = @_settings.currentTaxonomyCode
        @ajaxCall('/monitoring/dashboard/charts/hierarchy', query, (response) =>
          @hierarchyNavigator = new Monitoring.Views.Charts.HierarchyNavigator(@path, response, {
            ordered: true,
            tags_limit: 10,
            show_limited: true
          })
          @data = @hierarchyNavigator.extractData()
          @afterAppendHTML()
        )
      )
    return this

  afterAppendHTML: ->
    @$el.find('.chart').html('')
    if @_dataIsEmpty()
      @$el.find('.chart').addClass('no-data')
    else
      @$el.find('.chart').removeClass('no-data')
      setTimeout => # to avoid the harmless "Uncaught TypeError: a.onContainerClick is not a function"
        @chart = new Highcharts.Chart(@_getOptions())
        @trigger('masonry')
      , 20
    $(this.el).find("#path").html(@template_path(tree_path: @_path()))
    @$el.removeClass('processing')

  _path: ->
    if @hierarchyNavigator then @hierarchyNavigator.path else @path

  _dataIsEmpty: ->
    @hierarchyNavigator.dataIsEmpty()

  _series: ->
    series = []
    total=0
    for tag in @data
      total = total + tag.y
    for tag in @data
      serie_data = []
      percentage = ((tag.y/total)*100).toFixed(2)
      serie_element = $.extend({}, tag);
      serie_name = serie_element.name
      serie_element.original_name = serie_name
      serie_element['percentage'] = percentage
      serie_element.name = serie_name + " (#{percentage}%)"
      serie_data.push serie_element
      single_serie = {
        name: serie_name
        data: serie_data
        point:
          events:
            click: @dispatchEvent
      }
      series.push single_serie unless tag.y == 0
    series

  deepInto: (event) =>
    target_name = event.point.original_name.trim()
    if @hierarchyNavigator.deepInto(target_name)
      @afterAppend()

  onSubpath: (event) =>
    text = @htmlDecode(event.target.innerHTML.trim())
    if @hierarchyNavigator.onSubpath(text)
      @afterAppend()

  dispatchEvent: (event)=> 
    if @inClickWindowTime
      clearTimeout(@delayed_timeout) if @delayed_timeout
      @deepInto(event)
      @inClickWindowTime = false
    else
      @delayed_timeout = setTimeout((=>@_chartClick event), 400)
      @inClickWindowTime = true

  _chartClick:(event)=>
    @inClickWindowTime = false
    @createPreviewDashboard(@getNewQuery(event))
    false

  getNewQuery: (event) ->
    tags = _.uniq(@_join_tags(event.point))
    query = @searchQuery.deepCopy()
    if _.isEmpty(query.get('primary_tags'))
      key = 'primary_tags'
    else if query.get('primary_tags')[0] == 'allTags'
      key = 'primary_tags'
    else
      key = 'secondary_tags'
    query.set(key, tags)
    return query

  _join_tags: (node) ->
    tags = []
    if node.tags
      tags = tags.concat node.tags
    if node.children
      for i in [0...node.children.length]
        tags = tags.concat @_join_tags node.children[i]
    tags

  onMouseOver: (event) =>
    $(event.target).addClass("link-path")

  onMouseOut: (event) =>
    $(event.target).removeClass("link-path")

  toggleMaximize: =>
    @_settings.maximized = !@_settings.maximized
    @$el.toggleClass('h2')
    @trigger('chartsChange')
    @afterAppend()

  toggleReducedTree: =>
    @hierarchyNavigator.toggleReducedTree()
    @_settings.reduced_tree = !@_settings.reduced_tree
    @trigger('chartsChange')
    @afterAppend()

  htmlDecode: (input) ->
    e = document.createElement('div')
    e.innerHTML = input
    e.childNodes[0].nodeValue

  _getOptions: ->
    options = {
      chart:
        renderTo: @$el.find('.chart')[0]
        type: "bar"
        marginBottom: 45
        marginTop: 35
      title:
        text: null
      legend:
        align: 'right'
        verticalAlign: 'top'
        x: 0
        y: 40
        floating: false
        layout: "vertical"
      plotOptions:
        bar:
          dataLabels: 
            enabled: true
          cursor: 'pointer'
          showInLegend: true
          borderColor: "rgba(0,0,0,0)"
          point:
            events:
              legendItemClick: @eventDispatch
        series:
          groupPadding: 0
      xAxis: {
        type: "linear"
        labels: 
          enabled: false
      }
      exporting:
        chartOptions:
            title:
              text: ["root"].concat(@_path()).join(" | ")
        filename: ["root"].concat(@_path()).join(" | ")
      tooltip:
        followPointer: true
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
        formatter: @_tooltipFormatter
      isHierarchical: true
      isBarHierarchyNavigation: true
    }
    options.series = @_series()
    options['exporting'] = @_getExportingOptions()
    options.exporting.buttons.contextButton.menuItems = @_menuOptions()
    return options

  _tooltipFormatter: () ->
    if @key
      "<b>#{@point.original_name}</b><br/>Cantidad: #{@point.y} (#{Math.round(@percentage * 10) / 10}%)"
    else
      false

  _menuOptions: => 
    menuItems = Highcharts.getOptions().exporting.buttons.contextButton.menuItems
    menuItems = menuItems.concat({separator:true})
    unless window.sharedSession
      menuItems = menuItems.concat({
        text: if @_settings.maximized then I18n.t('monitoring.dashboard.charts.export_options.normal') else I18n.t('monitoring.dashboard.charts.export_options.maximize')
        onclick: (() => @toggleMaximize())
      })
    menuItems = menuItems.concat({
      text: if @_settings.reduced_tree then I18n.t('monitoring.dashboard.charts.display_all_tags') else I18n.t('monitoring.dashboard.charts.reduce_tags')
      onclick: (() => @toggleReducedTree())
    })
    menuItems = menuItems.concat(@exportingOptions)

  _getExportingOptions: ->
    return buttons:
      contextButton:
        menuItems: []
        x: -12

  onClickChangeHierarchy: (evt) ->
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')

  changeTaxonomy: (evt) ->
    chosenTaxonomyName = $(evt.target).text()
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')
    taxonomy = @taxonomiesRepository.taxonomyWithName(chosenTaxonomyName)
    @_settings.currentTaxonomyCode = taxonomy.get('code')
    query = @searchQuery.deepCopy()
    query.set('taxonomy_code', @_settings.currentTaxonomyCode)
    @ajaxCall('/monitoring/dashboard/charts/hierarchy', query.toJSON(), (response) =>
      @hierarchyNavigator = new Monitoring.Views.Charts.HierarchyNavigator(@path, response, {
        ordered: true,
        tags_limit: 10,
        show_limited: true
      })
      unless @hierarchyNavigator.existsPathInTree()
        @path = @options.settings.path || []
        @hierarchyNavigator.onSubpath('')
      @afterAppend()
    )
